import { useCallback, useState } from 'react';
import { bootstrapSuperuser } from '../api/bootstrapApi';

const BUSINESS_TYPE_DEFAULT = 'children_playhouse';

const resolveErrorMessage = (error, t) => {
  const code = error?.data?.code;
  if (code === 'SUPERUSER_ALREADY_EXISTS') {
    return t('bootstrapAlreadyExists');
  }
  if (code === 'USERNAME_ALREADY_EXISTS') {
    return t('bootstrapUsernameTaken');
  }
  if (error?.status === 400) {
    return t('bootstrapInvalid');
  }
  return t('bootstrapFailed');
};

export const useBootstrapForm = ({ t }) => {
  const [formState, setFormState] = useState({
    username: '',
    password: '',
    organization_name: '',
    business_type: BUSINESS_TYPE_DEFAULT,
    owner_name: '',
    email: '',
    phone: '',
    website: '',
    physical_address: '',
  });
  const [errorMessage, setErrorMessage] = useState('');
  const [noticeMessage, setNoticeMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isComplete, setIsComplete] = useState(false);

  const handleInputChange = useCallback((event) => {
    const { name, value } = event.target;
    setFormState((prevState) => ({ ...prevState, [name]: value }));
  }, []);

  const handleSubmit = useCallback(
    async (event) => {
      event.preventDefault();
      setErrorMessage('');
      setNoticeMessage('');
      setIsSubmitting(true);

      try {
        await bootstrapSuperuser({
          username: formState.username.trim(),
          password: formState.password,
          organization_name: formState.organization_name.trim(),
          business_type: formState.business_type,
          owner_name: formState.owner_name.trim(),
          email: formState.email.trim(),
          phone: formState.phone.trim(),
          website: formState.website.trim(),
          physical_address: formState.physical_address.trim(),
        });
        setIsComplete(true);
        setNoticeMessage(t('bootstrapSuccess'));
        setFormState({
          username: '',
          password: '',
          organization_name: '',
          business_type: BUSINESS_TYPE_DEFAULT,
          owner_name: '',
          email: '',
          phone: '',
          website: '',
          physical_address: '',
        });
      } catch (error) {
        setErrorMessage(resolveErrorMessage(error, t));
      } finally {
        setIsSubmitting(false);
      }
    },
    [
      formState.business_type,
      formState.email,
      formState.organization_name,
      formState.owner_name,
      formState.password,
      formState.phone,
      formState.physical_address,
      formState.username,
      formState.website,
      t,
    ],
  );

  return {
    formState,
    errorMessage,
    noticeMessage,
    isSubmitting,
    isComplete,
    handleInputChange,
    handleSubmit,
  };
};
